import { cn } from '@gettactic/helpers';

export const classes = {
  label: 'block font-medium text-sm mb-1.5 text-muted-foreground',
  value: 'font-inter font-normal text-sm text-gray-900',
  selectTrigger: cn(
    'w-full border-1 border-gray-200 hover:border-gray-300 rounded-md z-dropdown bg-white justify-between pr-4 focus:ring-0'
  )
};
